import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import _ from 'lodash';
import moment from 'moment';
import Chart from 'chart.js';

class ChartGazetters extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            gazetters: props.gazetters,
            rangeDates: [],
            labels: [],
            datasets: [],
            chart: {},
        };
    }

    componentDidMount() {
        this.createRangeDates();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { gazetters } = nextProps;

        if (!gazetters.length) {
            return;
        }

        this.setState({
            gazetters,
        }, () => {
            this.createRangeDates();
        })
    }

    createLabels() {
        let { from, until } = this.props;

        let labels = [];
        let currentDate = moment(from);
        let untilMoment = moment(until);

        while (currentDate <= untilMoment) {
            labels.push( moment(currentDate).startOf('day').format('DD.MM.YYYY') );
            currentDate = moment(currentDate).add(1, 'days');
        }

        return labels;
    }

    createRangeDates() {
        let { gazetters, chart } = this.state;

        const labels = this.createLabels();
        const values = [];

        labels.forEach((item) => {
           // labels.push(moment    (item.date).utc().endOf('day').format('MM-DD-YYYY'));
            let count = 0;
            gazetters.forEach((gazetter) => {
                if (item === moment(gazetter.date).utc().startOf('day').format('DD.MM.YYYY')) {
                     count++;
                }
            });

            values.push(count);
        });

        const datasets = [{
            label: 'Gazetters',
            backgroundColor: 'green',
            borderColor: 'green',
            stack: 'Stack 0',
            data: values,
        }];

        if (_.isEmpty(chart)) {
            chart = this.createChart(labels, datasets);
        } else {
            chart = this.updateChart(chart, labels, datasets);
        }

        this.setState({
            labels,
            datasets,
            chart,
        });
    }

    updateChart(chart, labels, datasets) {
        chart.data.labels = labels;
        chart.data.datasets = datasets;

        chart.update(0);

        return chart;
    }

    createChart(labels, datasets) {
        const ctx = this.refs.chartGazetters.getContext('2d');
        const chart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels,
                datasets,
            },
            options: {
                tooltips: {
                    mode: 'label'
                },
                scales: {
                    xAxes: [{
                        stacked: true
                    }],
                    yAxes: [{
                        stacked: true
                    }]
                }
            }
        });

        return chart;
    }

    render() {
       return (
            <div className='row'>
                <div className='col-xs-12'>
                    <canvas ref='chartGazetters' />
                </div>
            </div>
        );
    }
}

export default connect(
    (state, { gazetters }) => {
        return {
            gazetters,
        };
    },
    dispatch => bindActionCreators({}, dispatch),
)(ChartGazetters);



// WEBPACK FOOTER //
// ./app/components/Statistics/St/Charts/Gazetters.jsx